const loadedUrls = new Set();

export function isImageCached(url) {
  return Boolean(url && loadedUrls.has(url));
}

export function preloadImage(url) {
  if (!url || loadedUrls.has(url)) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    const img = new Image();
    img.decoding = "async";
    img.onload = () => {
      loadedUrls.add(url);
      resolve(true);
    };
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

export function clearImageCache() {
  loadedUrls.clear();
}
